/**
 * SAH Client Journey Utopia — tenant feature-flag keys.
 *
 * These two live switches are exact-tenant mirrors of provider operational
 * controls v2. Global rows are descriptive only and missing keys resolve off.
 */

export const SAH_UTOPIA_FLAG_KEYS = [
  'SAH_UNIFIED_ACTION_QUEUE',
  'SAH_READINESS_EXPLORATION_PHASE',
] as const;

export const SAH_RETIRED_FLAG_KEYS = [
  'SAH_JOURNEY_DEFAULT_TAB',
  'SAH_OVERVIEW_CHROME',
  'SAH_COMPOSE_DEFAULT_REDIRECT',
] as const;

export type SahUtopiaFlagKey = (typeof SAH_UTOPIA_FLAG_KEYS)[number];

export const SAH_UTOPIA_DEFAULT_FLAGS: Record<SahUtopiaFlagKey, boolean> = {
  SAH_UNIFIED_ACTION_QUEUE: false,
  SAH_READINESS_EXPLORATION_PHASE: false,
};

export const SAH_UTOPIA_FLAG_DESCRIPTIONS: Record<SahUtopiaFlagKey, string> = {
  SAH_UNIFIED_ACTION_QUEUE:
    'Use the unified SAH action queue on Journey, workflow rail, and Overview follow-ups.',
  SAH_READINESS_EXPLORATION_PHASE:
    'Show advisory vs required severities on CarePlanReadinessRail (exploration phase).',
};

export function isSahUtopiaFlagKey(value: string): value is SahUtopiaFlagKey {
  return (SAH_UTOPIA_FLAG_KEYS as readonly string[]).includes(value);
}

export function isRetiredSahFlagKey(value: string): boolean {
  return (SAH_RETIRED_FLAG_KEYS as readonly string[]).includes(value);
}

/**
 * Resolve a utopia flag from a merged flag map (tenant overrides global).
 * Missing keys resolve off. The provider control migration creates exact rows
 * for every existing and new tenant, so absence is a containment signal.
 */
export function isSahUtopiaFlagEnabled(
  flags: Record<string, boolean> | null | undefined,
  key: SahUtopiaFlagKey,
): boolean {
  return flags?.[key] ?? SAH_UTOPIA_DEFAULT_FLAGS[key];
}
